import { Model } from "../alcance/models/model";
import { Andar } from "./andar";
import { Documento } from "./documento";
import { Estabelecimento } from "./estabelecimento";
import { Grupo } from "./grupo";
import { Modulo } from "./modulo";
import { Turno } from "./turno";

export class Edificacao extends Model{

    private _modulos!: Modulo[];

    estabelecimento!: Estabelecimento;
    estabelecimento_id!: number;
    grupo?: Grupo;
    grupo_id?: number;
    andares!: Andar[];
    turnos!: Turno[];
    documentos!: Documento[];
    sequencia!: number;
    descricao!: string;
    codigo_app!: string;
    email_gestor?: string;
    // tel_bombeiro?: string;
    gps_precisao!: number;
    qtd_mensagens!: number;
    plano_emergencia!: string;
    imagem!: string;
    emails!: {
        descricao: string;
        disponivel: boolean;
        notificar: boolean;
        emails: string[];
    }[];    
    updated_at!: string;

    set modulos(m: Modulo[]){
        this._modulos = m;
    }

    get modulos(): Modulo[]{
        let mod: Modulo[] = [];
        this._modulos.forEach(m => {
            if(!mod.find(i => i.id == m.id))
                mod.push(m)
        })
        return mod;
    }
}
